import { inject, Injectable } from "@angular/core";
import { AccountMarketplace, DspAdvertiserDeal } from "@front/m19-api-client";
import { AccountSelectionService, DspService, isStvAvailable, OrganizationService } from "@front/m19-services";
import { map, Observable, shareReplay, switchMap } from "rxjs";

@Injectable()
export class DspFormService {
  private readonly accountSelectionService = inject(AccountSelectionService);
  private readonly dspService = inject(DspService);
  private readonly organizationService = inject(OrganizationService);

  readonly accountMarketplace$: Observable<AccountMarketplace> =
    this.accountSelectionService.singleAccountMarketplaceSelection$;

  readonly videoDeals$: Observable<DspAdvertiserDeal[]> = this.accountMarketplace$.pipe(
    switchMap((am) => this.dspService.getDspAdvertiserDeals(am.dspAdvertiserId!)),
    shareReplay(1),
  );

  readonly stvAvailable$: Observable<boolean> = this.accountMarketplace$.pipe(
    map((am) => isStvAvailable(am.marketplace)),
    shareReplay(1),
  );

  readonly videoDealAvailable$: Observable<boolean> = this.videoDeals$.pipe(
    map((deals) => deals.length > 0),
    shareReplay(1),
  );

  readonly allowAgencyFee$: Observable<boolean> = this.accountMarketplace$.pipe(
    map((am) => am.resourceOrganizationId),
    switchMap((organizationId) => this.organizationService.find(organizationId)),
    map((organization) => !!organization?.agencyFeeAllowed),
    shareReplay(1),
  );
}
